export const IFRAME_SANDBOX_VALUE =
  'allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups';
export const SRC_SYSTEM_IFRAME_ID = 'vcop-src-system-frame';
export const SRC_SYSTEM_IFRAME_WRAPPER_ID = 'vcop-src-system';
